import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Check, Package } from "lucide-react";
import { Screen, ScrollArea, BottomBar, PrimaryButton } from "@/components/jk/ui";
import { Card, SectionLabel, FullScreenLoader } from "@/components/jk/kit";
import api from "@/lib/api";

const ProductOrderDone = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/public/product-orders/${orderId}`)
      .then(({ data }) => setOrder(data.order))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [orderId]);

  if (loading) return <FullScreenLoader />;

  return (
    <Screen testid="product-order-done-screen">
      <ScrollArea className="px-6 pt-16">
        <div className="flex flex-col items-center text-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[#111111]" data-testid="done-icon">
            <Check size={40} strokeWidth={2.5} className="text-white" />
          </div>
          <h1 className="mt-6 text-[28px] font-bold leading-tight tracking-[-0.02em] text-[#111111]" data-testid="done-title">
            Order placed!
          </h1>
          <p className="mt-2 text-[14px] leading-relaxed text-[#666666]">
            Your order will be dispatched in 2-3 business days. Check your email for confirmation.
          </p>
        </div>

        {order && (
          <Card className="mt-8" data-testid="order-details">
            <SectionLabel className="mb-3">Order details</SectionLabel>

            <div className="flex items-center gap-2 mb-3">
              <Package size={14} className="text-[#666]" />
              <span className="text-[12px] font-mono text-[#666]" data-testid="order-reference">#{order.order_reference}</span>
            </div>

            <p className="text-[17px] font-bold text-[#111]" data-testid="order-product-name">{order.product_name}</p>

            <div className="mt-4 border-t border-[#f0ede8] pt-4 space-y-1">
              <p className="text-[12px] font-semibold uppercase tracking-wide text-[#666]">Delivering to</p>
              <p className="text-[14px] font-semibold text-[#111]" data-testid="order-client-name">{order.client_name}</p>
              <p className="text-[13px] leading-relaxed text-[#555]" data-testid="order-address">{order.client_address}</p>
            </div>

            <div className="mt-4 rounded-[12px] bg-[var(--jk-periwinkle)] p-3">
              <p className="text-[13px] text-[#444]">
                You will receive tracking details by email once your order is shipped.
              </p>
            </div>

            <p className="mt-4 text-[11px] text-[#999]">
              Sold by Monetyze Technologies Pvt Ltd · GSTIN 34AAMCM5316N1Z3
            </p>
          </Card>
        )}

        <div className="h-8" />
      </ScrollArea>

      <BottomBar>
        <PrimaryButton
          testid="back-to-profile"
          onClick={() => navigate(-2)}
        >
          Back to astrologer profile
        </PrimaryButton>
      </BottomBar>
    </Screen>
  );
};

export default ProductOrderDone;
